import React from 'react';

function Governance() {
  return (
    <div>
      <div className="header">
        <h1>Governance & Elections</h1>
        <p>Democratic Principles & Transparent Operations</p>
      </div>

      <div className="container">
        <div className="content">
          <h2>About Sarayu Urban Multi state Co-operative Credit Society</h2>
          <p>Sarayu Urban Multi state Co-operative Credit Society is a registered financial cooperative operating across multiple states in India. We are committed to serving our members with integrity and transparency, adhering to all regulatory guidelines and cooperative principles.</p>

          <h2>Governance Structure</h2>
          <p>Our organization operates under a democratic governance model with elected representatives from our member base. The Board of Directors is responsible for strategic decisions and ensuring member interests are protected.</p>

          <h3>Board Composition:</h3>
          <p>• Elected Members from member base</p>
          <p>• Independent Directors</p>
          <p>• Nominated Members for specialized expertise</p>

          <h2>Election Process</h2>
          <p>We conduct fair and transparent elections to ensure every member has a voice in the organization's leadership. Our election process follows cooperative principles and regulatory requirements.</p>

          <h3>Key Election Details:</h3>
          <p>• Elections held every 5 years</p>
          <p>• All members have one vote regardless of shareholding</p>
          <p>• Conducted under transparent and neutral supervision</p>
          <p>• Results published immediately after verification</p>

          {/* PDF Download Section */}
          <div className="pdf-section">
            <h2>Download Important Documents</h2>
<div className="pdf-box">
  <h3>Preliminary Voters' List 29 June 2026</h3>
  <p>
    Official preliminary electoral roll for the 2026 Society Election. Includes the list
    of eligible voters along with instructions for submitting objections, corrections,
    additions, and deletions within the prescribed timeline before the final voter list
    is published.
  </p>
  <a href="/pdfs/doc1.pdf" download className="pdf-button">
    Download PDF
  </a>
</div>

<div className="pdf-box">
  <h3>Voters' List Publication Report 29 June 2026</h3>
  <p>
    Official covering letter certifying that the preliminary voters' list has been
    displayed on the society's notice board and published on the official websitec  </p>
  <a href="/pdfs/doc2.pdf" download className="pdf-button">
    Download PDF
  </a>
</div>

<div className="pdf-box">
    <h3>List of Nomination Forms Received 23 July 2026</h3>
  

  <p>
    Official notification issued by the Election Returning Officer for the
    Saryu Urban Multistate Co-operative Credit Society Election 2026,
    publishing the list of valid nomination forms received between
    20 July 2026 and 23 July 2026.
  </p>

  <a href="/pdfs/doc4.pdf" download className="pdf-button">
    Download PDF
  </a>

</div>


<div className="pdf-box">
  <h3>List of Valid Nominations after Scrutiny 24 July 2026</h3>

  <p>
    Official notification issued by the Election Returning Officer for the
    Saryu Urban Multi State Co-operative Credit Society Election 2026,
    publishing the list of valid nominations after scrutiny. 
  </p>

  <a href="/pdfs/doc5.pdf" download className="pdf-button">
    Download PDF
  </a>
</div>


<div className="pdf-box">
  <h3>Final List of Contesting Candidates – 25 July 2026</h3>

  <p>
    Official notification issued by the Election Returning Officer for the
    Saryu Urban Multi State Co-operative Credit Society Election 2026,
    announcing the final list of contesting candidates after the completion
    of the nomination scrutiny and withdrawal process.
  </p>

  <a href="/pdfs/doc6.pdf" download className="pdf-button">
    Download PDF
  </a>
</div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Governance;